import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { replaceEmptyAd } from '../store/modules/replaceEmptyAd';
import { cLog } from './consoleLog';

export const useChangeHouse = () => {
  const dispatch = useDispatch();
  return useCallback(
    (event) => {
      try {
        if (event.data) {
          const message = JSON.parse(event.data);
          if (message && message.msg_type && message.msg_type === 'resize-me') {
            let shouldCollapseAd = false;

            for (let index in message.key_value) {
              let key = message.key_value[index].key;
              let value = message.key_value[index].value;

              if (key === 'r_nh' && value === '0') {
                shouldCollapseAd = true;
              }
            }

            if (shouldCollapseAd) {
              dispatch(replaceEmptyAd());
            }
          }
        }
      } catch (e) {
        cLog(`change house error : ${e}`);
      }
    },
    [dispatch]
  );
};

export const useChangeHouseEvenetListener = () => {
  const changeHouse = useChangeHouse();
  useEffect(() => {
    window.addEventListener('message', changeHouse);
    return () => {
      window.removeEventListener('message', changeHouse);
    };
  }, [changeHouse]);
};
